/**A Hook that returns an object containing MUI SX functions or objects. Functions take theme as a parameter and return an object.
 *
 * @returns {object}
 */
const useStyles = () => {
    const fieldLabelSx = (theme) => {
        return {
            color: theme.palette.grey['header'],
            fontSize: '0.8125rem',
            fontWeight: 600,
        };
    };

    const scholarshipDataReadOnlySx = (theme) => {
        return {
            fontSize: '0.9375rem',
            p: theme.spacing(2),
            color: theme.palette.grey['field-text'],
            backgroundColor: theme.palette.grey['disabled-background'],
            border: `1px solid ${theme.palette.grey['disabled-background']}`,
            borderRadius: 2.5,
            width: '12.625rem',
        };
    };

    const scholarshipDataRowSx = (theme) => {
        return {
            mt: theme.spacing(3),
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing(4),
            justifyContent: 'space-evenly',
        };
    };

    const checkboxSx = (theme) => {
        return {
            mt: theme.spacing(1),
            '& .MuiTypography-root': {
                color: theme.palette.grey['header'],
                fontSize: '0.9375rem',
            },
        };
    };

    const selectSx = (theme) => {
        return {
            width: '12.625rem',
            fontSize: '0.9375rem',
            '& .Mui-disabled': {
                backgroundColor: theme.palette.grey['disabled-background'],
            },
        };
    };

    const instructionsSx = (theme) => {
        return {
            p: theme.spacing(2),
            fontSize: '0.9375rem',
            color: theme.palette.grey['table-text'],
        };
    };

    const textFieldSx = (theme) => {
        return {
            '& .MuiOutlinedInput-root': {
                fontSize: '0.9375rem',
            },
            '& .Mui-disabled': {
                backgroundColor: (theme) => theme.palette.grey['disabled-background'],
            },
        };
    };

    const dateFieldSx = {
        '.Mui-disabled': {
            fontSize: '0.9375rem',
            WebkitTextFillColor: 'unset',
            backgroundColor: (theme) => theme.palette.grey['disabled-background'],
            color: (theme) => theme.palette.grey['field-text'],
            opacity: 1,
            border: (theme) => `1px solid ${theme.palette.grey['disabled-background']}`,
        },
    };

    return {
        fieldLabelSx,
        scholarshipDataReadOnlySx,
        scholarshipDataRowSx,
        checkboxSx,
        selectSx,
        instructionsSx,
        textFieldSx,
        dateFieldSx,
    };
};

export default useStyles;

